module.exports = __webpack_public_path__ + "static/media/29.0978619e.jpg";